import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        formCategory: '='
    },
    template: `
        <a class="btn main small" ng-click="vm.manageLanguages(vm.form)">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor (ModalService, QuestionCategoryResource) {
        this.ModalService = ModalService;
        this.QuestionCategoryResource = QuestionCategoryResource;
    }

    manageLanguages (form) {
        const { formCategory } = this;
        return this.ModalService.open({
            animation: true,
            template: `
                <modals-forms-formcategories-translation
                    update="vm.update()"
                    update-form="vm.form"
                    form-category="vm.formCategory"
                    cancel="vm.$uibModalInstance.dismiss()"
                    class="wrapper"></modals-forms-formcategories-translation>
                `,
            size: 'xlarge',
            controller ($uibModalInstance, QuestionCategoryResource) {
                this.$uibModalInstance = $uibModalInstance;
                this.formCategory = formCategory;
                this.QuestionCategoryResource = QuestionCategoryResource;
                this.form = form;

                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/formcategories/translation/index.js